// Saneo en el navegador del texto enriquecido de los párrafos (lista blanca de etiquetas,
// atributos y estilos). Se usa antes de cualquier innerHTML en el editor: el documento
// creado con DOMParser es inerte (no ejecuta scripts ni manejadores). El servidor vuelve
// a sanear con sanitize-html al renderizar.
const TAGS = new Set(["P", "BR", "B", "STRONG", "I", "EM", "U", "S", "A", "SPAN", "UL", "OL", "LI", "DIV", "SUP", "SUB"]);
const STYLE_PROPS: Record<string, RegExp> = {
  color: /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\))$/i,
  "background-color": /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\))$/i,
  "text-align": /^(left|right|center|justify)$/,
  "font-weight": /^(bold|normal|[1-9]00)$/,
  "font-style": /^(italic|normal)$/,
  "text-decoration": /^(underline|line-through|none)$/,
  "font-size": /^\d{1,2}px$/,
};
export const isSafeHref = (h: string): boolean => /^(https?:\/\/|mailto:|tel:|#$|\{\{baja_url\}\}$)/i.test(h.trim());

function cleanStyle(el: HTMLElement): string {
  const out: string[] = [];
  for (const prop of Object.keys(STYLE_PROPS)) {
    const v = el.style.getPropertyValue(prop).trim();
    if (v && STYLE_PROPS[prop]!.test(v)) out.push(`${prop}:${v}`);
  }
  return out.join(";");
}

function walk(src: Node, dst: Node, doc: Document): void {
  src.childNodes.forEach((n) => {
    if (n.nodeType === Node.TEXT_NODE) { dst.appendChild(doc.createTextNode(n.textContent ?? "")); return; }
    if (n.nodeType !== Node.ELEMENT_NODE) return;
    const el = n as HTMLElement;
    let tag = el.tagName;
    if (tag === "SCRIPT" || tag === "STYLE" || tag === "IFRAME" || tag === "OBJECT" || tag === "TEMPLATE") return;
    // <font color> (execCommand antiguo) → span con color.
    let fontColor: string | null = null;
    if (tag === "FONT") { fontColor = el.getAttribute("color"); tag = "SPAN"; }
    if (!TAGS.has(tag)) { walk(el, dst, doc); return; } // desenvuelve etiquetas no permitidas
    const out = doc.createElement(tag.toLowerCase());
    let style = cleanStyle(el);
    if (fontColor && STYLE_PROPS["color"]!.test(fontColor)) style = `color:${fontColor}${style ? `;${style}` : ""}`;
    if (style) out.setAttribute("style", style);
    if (tag === "A") {
      const href = el.getAttribute("href") ?? "";
      if (isSafeHref(href)) out.setAttribute("href", href.trim());
      out.setAttribute("target", "_blank");
    }
    walk(el, out, doc);
    dst.appendChild(out);
  });
}

/** HTML limpio (lista blanca) apto para innerHTML. */
export function cleanRichHtml(html: string): string {
  const parsed = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const doc = document.implementation.createHTMLDocument("");
  const root = doc.createElement("div");
  walk(parsed.body, root, doc);
  return root.innerHTML;
}

/** Texto plano de un HTML (para miniaturas, auditoría local). */
export function htmlText(html: string): string {
  return new DOMParser().parseFromString(html, "text/html").body.textContent ?? "";
}
